(function(app, ng) {

    app.component("contactInfo",
        {
            templateUrl: "/App/Client/Components/contactinfo-template.html",
            controller: contactInfoController,
            require: {
                clientSidebar: "^clientSidebar"
            }
        });

    contactInfoController.$inject = ["$rootScope"];
    function contactInfoController($rootScope) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
            });

        this.$onInit = function() {
            $ctrl.primaryAdvisor = this.clientSidebar.parent.client.PrimaryAdvisor;
            $ctrl.primaryEmailAddress = this.clientSidebar.parent.client.Person.PrimaryEmailAddress;
            $ctrl.primaryPhoneNumber = this.clientSidebar.parent.client.Person.PrimaryPhoneNumber;
            $ctrl.primaryPhysicalAddress = this.clientSidebar.parent.client.Person.PrimaryPhysicalAddress;
        }

        $rootScope.$on("primaryAdvisorUpdated",
            function(event, advisor) {
                $ctrl.primaryAdvisor = advisor;
            });

        $rootScope.$on("primaryEmailAddressUpdated",
            function(event, email) {
                $ctrl.primaryEmailAddress = email;
            });

        $rootScope.$on("primaryPhoneNumberUpdated",
            function(event, phoneNumber) {
                $ctrl.primaryPhoneNumber = phoneNumber;
            });

        $rootScope.$on("primaryPhysicalAddressUpdated",
            function(event, physicalAddress) {
                $ctrl.primaryPhysicalAddress = physicalAddress;
            });
    }

})(window.app, window.angular); //jshint ignore:line